import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Typeruns } from '../../../../../../../core/entities/typeruns.model';
import { TyperunsService } from '../../../../../../../core/repositories/typeruns.service'

@Injectable()
export class EditDialogsTyperunsService {

  typeruns: Typeruns = new Typeruns();
  originalTyperuns: Typeruns = new Typeruns();
  parametersInput: Typeruns = new Typeruns();

  allTyperuns: Typeruns[] = [];
  changetitulo: boolean = false;

  constructor(private typerunsService: TyperunsService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.typeruns = data.typerun;
    this.changetitulo = data.titulochange;
    this.originalTyperuns = _.cloneDeep(this.typeruns);
    console.log(data);
    return this.typerunsService.findAll().pipe(map((result: Typeruns[]) => {
      this.allTyperuns = result;
      if (Utils.noUndfAndNull(data.typerun)) {
        this.typeruns = _.cloneDeep(data.typerun);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el typerun
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.typeruns.id, "")) {

      /*comparamos el typerun original con el modificado*/
      let compareTyperun = this.compare(this.typeruns, this.originalTyperuns);

      if(compareTyperun){
        return of(-1);
      }else{
        return this.typerunsService.postTyperun(this.typeruns);
      }

    }else{
      return this.typerunsService.postTyperun(this.typeruns);
    }
  }

  /**
  * @description
  * Comprueba si dos Typeruns son iguales.
  * @param datoX Typerun 1
  * @param datoY Typerun 2
  * @returns True si son iguales
  */
  public compare(itemX:Typeruns, itemY:Typeruns):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if(itemY.id == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)) && (itemX.code !== ""))
          return false;
      }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.typeruns = new Typeruns();
  }

}
